import { formatRelativeLastOpenedDate } from "../../util";
import { useMemo } from "react";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

export const ProjectInfo = ({ date, sitesCount }: { date?: Date | string | null; sitesCount: number }) => {
  const { t } = useTranslation();

  const formattedDate = useMemo(() => {
    return formatRelativeLastOpenedDate(date);
  }, [date]);

  return (
    <span className="text-xs font-normal text-text-base-secondary-a">
      {formattedDate} · {t("workspaces.project_info.sites_count", { sitesCount })}
    </span>
  );
};
